module.exports = __webpack_public_path__ + "ce4aa2caa506fad596b6ae436c6152c2.png";